import { CommonModule } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
  ViewEncapsulation,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from "@angular/forms";
import { BackendApiService } from "../../../../app/services/backend-api.service";
import { BaseUrlConstantsService } from "../../../../app/services/base-url-constants.service";

export interface DoorOperationData {
  on_id: number;
  on_time: string;
  off_id: number;
  off_time: string;
  duration_seconds: number;
  type: "open" | "close";
  client_id: string;
  oven_id: string;
}

export interface ModalFormData {
  comment: string;
  supervisorName: string;
  doorOperationData: DoorOperationData;
}

@Component({
  selector: "oven-door-comment-modal",
  templateUrl: "./door-comment-modal.html",
  styleUrls: ["./door-comment-modal.component.scss"],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
})
export class DoorComponentModal implements OnChanges {
  @Input() isVisible: boolean = false;
  @Input() title: string = "Add Comment";
  @Input() doorData: DoorOperationData | null = null;
  @Output() onSubmit = new EventEmitter<ModalFormData | null>();
  @Output() onCancel = new EventEmitter<void>();

  form: FormGroup;
  public baseOvenUrl = BaseUrlConstantsService.OVEN_BASE_URL;

  constructor(private fb: FormBuilder, private srv: BackendApiService) {
    this.form = this.fb.group({
      supervisorName: ["", Validators.required],
      comment: ["", Validators.required],
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["doorData"] && this.doorData) {
      this.form.reset({
        supervisorName: "",
        comment: "",
      });
    }
  }

  get doorOperationType(): string {
    return this.doorData?.type === "open" ? "Door Opening" : "Door Closing";
  }

  get startTime(): string {
    return this.doorData ? this.formatDateTime(this.doorData.on_time) : "";
  }

  get endTime(): string {
    return this.doorData ? this.formatDateTime(this.doorData.off_time) : "";
  }

  get durationFormatted(): string {
    if (!this.doorData) return "";
    const minutes = Math.floor(this.doorData.duration_seconds / 60);
    const seconds = this.doorData.duration_seconds % 60;
    return `${minutes}m ${seconds}s`;
  }

  private formatDateTime(dateTimeString: string): string {
    const date = new Date(dateTimeString);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  }

  submitForm(): void {
    let body = {
      supervisorName: this.form.value.supervisorName,
      comment: this.form.value.comment,
      ...this.doorData,
      type: this.doorData.type,
    };
    this.srv
      .postData(
        // `http://localhost:3024/api/v1/oven-assets/add-door-comments/${this.doorData.client_id}/${this.doorData.oven_id}`,
        `${this.baseOvenUrl}api/v1/oven-assets/add-door-comments/${this.doorData.client_id}/${this.doorData.oven_id}`,
        body
      )
      .then((data: any) => {
        const { code, status } = data;

        if (code != 200 || status != "success") {
          this.srv.showError("Failed to add comment");
          return;
        }

        this.srv.showSuccess("Comment added!");
        this.onCancel.emit();
      })
      .catch((err) => {
        console.log(err);
        this.srv.showError("Failed to add comment");
      });
  }

  cancelForm(): void {
    this.onCancel.emit();
    this.form.reset();
  }
}
